import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  DisabledFiltersMap,
  DisabledFiltersState
} from 'interfaces/store/disabledFilters';

const initialDisabledFiltersState: DisabledFiltersState = {
  disabledFilters: {}
};

const disabledFiltersSlice = createSlice({
  name: 'disabledFilters',
  initialState: initialDisabledFiltersState,
  reducers: {
    setDisabledFilters: (state, action: PayloadAction<DisabledFiltersMap>) => {
      state.disabledFilters = action.payload;
    }
  }
});

export const { setDisabledFilters } = disabledFiltersSlice.actions;

export default disabledFiltersSlice.reducer;
